import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueParticles from 'vue-particles' //粒子效果

import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import Tinymce from 'tinymce'
// Vue.prototype.$tinymce = Tinymce; 

Vue.use(Element, { size: 'small', zIndex: 3000 });
Vue.use(VueParticles) 

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
